const keys = Object.freeze({
	ARROW_UP: 38,
	ARROW_DOWN: 40,
	TAB: 9,
	ENTER: 13,
	ESCAPE: 27,
});

export default keys;
